<template>
  <!--内容类别管理-->
  <div id="contentList">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto;white-space: normal;">
          <p>
            <input @keyup.enter="getList(1)" class="allInput" type="number" placeholder="类别ID" v-model="postData.id">
          </p>
          <p>
            <input @keyup.enter="getList(1)" class="allInput" type="text" placeholder="类别名称" v-model="postData.typeName">
          </p>
          <p v-if="onSearch">
            <input @keyup.enter="getList(1)" class="allInput" type="text" placeholder="Content Editor" v-model="postData.editor">
          </p>
          <p v-if="onSearch">
            <input @keyup.enter="getList(1)" class="allInput" type="text" placeholder="Content Owner" v-model="postData.owner">
          </p>
          <p v-if="onSearch">
            <cander v-model="postData.beginTime" :className="'allInput'" placeholderName="创建时间"  class="d_i" style="vertical-align: middle"></cander>
          </p>
          <p>
            <abbr class="d_i">
              <allSelect :chooseData="allStatus" :needReturn="'id'" :placeholder="'状态'" :matchValue="'name'" :showValue="'{{name}}'" v-model="postData.status">
              </allSelect>
            </abbr>
          </p>
        </div>
        <div style="width: auto;">
          <span class="colorCH c_p" style="text-decoration: underline" @click="tewoSearch()">{{onSearch ? '快速搜索':'高级搜索'}}</span>
          <button class="redButton" @click="selectCont">
            <i class="icon iconfont iconsousuo"></i>
            搜索
          </button>
          <button class="cancelButtonTwo" @click="selectEmpty">
            清空
          </button>
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div class="t_r"><button class="redButtonTwo m_b_10" @click="editToUrl"  v-if="nowApp.roles.indexOf('AppOwner') >= 0 || isSystemAdmin === 'true'">添加</button></div>
      <div>
        <table cellspacing="0" class="allTable">
          <thead>
          <tr>
            <th>类别ID</th>
            <th>类别名称</th>
            <th>Content Editor</th>
            <th>Content Owner</th>
            <th>创建时间</th>
            <th>状态</th>
            <th v-if="nowApp.roles.indexOf('AppOwner') >= 0 || isSystemAdmin === 'true'">操作</th>
          </tr>
          </thead>
          <tbody>
          <tr :key="index" v-for="(item, index) in myList">
            <td>{{item.id}}</td>
            <td>{{item.typeName}}</td>
            <td width="20%" style="max-width: 220px" :title="item.editors" class="NoWrap">{{item.editors}}</td>
            <td width="20%" style="max-width: 220px" :title="item.owners" class="NoWrap">{{item.owners}}</td>
            <td>{{item.creationTime}}</td>
            <td>{{item.isEnable ? '有效' : '无效'}}</td>
            <td @click="editContentType(item.id)" style="cursor: pointer;text-decoration:underline #408DEB;" class="colorBlue"  v-if="nowApp.roles.indexOf('AppOwner') >= 0 || isSystemAdmin === 'true'">编辑</td>
          </tr>
          </tbody>
        </table>
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contentList',
  data () {
    return {
      nowApp: JSON.parse(window.sessionStorage.getItem('nowApp')),
      isSystemAdmin: window.sessionStorage.getItem('isSystemAdmin'),
      onSearch: false,
      showModel: false,
      tabSwitch: 1,
      totalPage: 1,
      totalCount: 0,
      page: 1,
      postData: {
        id: '',
        status: -1,
        typeName: '',
        owner: '',
        editor: '',
        Status: '',
        beginTime: '',
        pageIndex: 1,
        pageSize: this.$commonJs.commonPageSize
      },
      myList: [],
      allStatus: [
        {
          id: -1,
          name: '全部'
        },
        {
          id: 1,
          name: '有效'
        },
        {
          id: 0,
          name: '无效'
        }
      ]
    }
  },
  created () {
    this.getList(1)
  },
  methods: {
    // 切换搜索条件
    tewoSearch () {
      this.onSearch = !this.onSearch
    },
    // 新建
    editToUrl () {
      this.$router.push({
        name: 'editCategoryList',
        params: {
          id: 0
        }
      })
    },
    getList (pageIndex) {
      this.postData.pageIndex = pageIndex
      let url = this.$commonJs.returnQuery('/api/contentType/all', this.postData)
      this.$axiox.get(url).then(msg => {
        this.page = pageIndex
        this.myList = msg.result.items
        this.totalPage = Math.ceil(msg.result.totalCount / this.postData.pageSize)
        this.totalCount = msg.result.totalCount
      })
    },
    selectCont () {
      this.getList(1)
    },
    confirModel () {
    },
    cancelModel () {
      this.showModel = false
    },
    editContentType (id) {
      this.$router.push({
        name: 'editCategoryList',
        params: {
          id: id
        }
      })
    },
    selectEmpty () {
      this.postData.id = ''
      this.postData.typeName = ''
      this.postData.editor = ''
      this.postData.owner = ''
      this.postData.beginTime = ''
      this.postData.status = '-1'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/mainDateManager/categoryList.vue